import * as React from 'react';
import theme from '../../utils/theme';
import { SketchPicker, ColorResult } from 'react-color';
import { BaseForm } from './Base';

export const spanClasses = 'w-100 bw0 db h2 br3';

type SelectProps = React.InputHTMLAttributes<HTMLSelectElement>;

export interface InputProps extends SelectProps {
  id: string;
  label: string;
  tooltip?: string;
  field: any;
  onValueChange: Function;
  defaultValue: any;
}

export interface ColorFieldState {
  visible: boolean;
}

export class ColorField extends React.Component<InputProps, ColorFieldState> {
  constructor(props: InputProps) {
    super(props);

    this.state = {
      visible: false,
    };
  }

  toggleView = () => {
    this.setState({
      visible: !this.state.visible,
    });
  };

  handleColorChange = (color: ColorResult) => {
    const { onValueChange } = this.props;

    onValueChange(this.props.field, color.hex);
  };

  render() {
    const { label, id, tooltip, defaultValue } = this.props;

    return (
      <BaseForm label={label} id={id} tooltip={tooltip}>
        <span className="input-reset bn bg-near-white hover-bg-black-10 pa2 pa3-ns br3 mb2 db">
          <button
            type="button"
            onClick={this.toggleView}
            className={spanClasses}
            style={{
              backgroundColor: defaultValue,
            }}
          >
            Click to assign
          </button>
          {this.state.visible && (
            <SketchPicker
              color={defaultValue}
              onChangeComplete={this.handleColorChange}
            />
          )}
        </span>
      </BaseForm>
    );
  }
}
